import { LoanStatusCatalog } from "@interfaces/catalogs";
import { BofuTabConfig, BofuTabValidationType } from "@interfaces/response";

// estatus para la pantalla de waiting room
export const WR_CODE = "CSCOF";
export const STATUS_WAITING_ROOM = "CSCOF";
export const STATUS_BURO_BLOQUEADO = "CSBBC";
export const STATUS_ESPERANDO_OFERTA = "CSEOF";
export const STATUS_AVANCE_EXPEDIENTE_DIGITAL = "CSAED";

export const TAX_SYSTEMS_CODES = {
  CREDIMOTO_PF: "CSCM2",
};

export const STATUS_CATALOG: LoanStatusCatalog = {
  // tofu pm
  registro_datos_personales: {
    code: "CSRUS",
    url: "/producto/creditosimple/registro_datos_personales",
  },
  validacion_telefono: {
    code: "CSVTE",
    url: "/producto/creditosimple/validacion_telefono",
  },
  // Mercader: perfil de ingresos y egresos del médico. Solo existe en el wizard v2 (no hay pantalla legacy).
  perfil_ingresos: {
    code: "CSPIE",
    url: "/v2/producto/creditosimple/perfil_ingresos",
  },
  datos_empresa_pm: {
    code: "CSDEM",
    url: "/producto/creditosimple/datos_empresa_pm",
  },
  consulta_ciec: {
    code: "CSAEM",
    url: "/producto/creditosimple/consulta_ciec",
  },
  uso_de_credito: {
    code: "CSUDC",
    url: "/producto/creditosimple/uso_de_credito",
  },
  presencia_digital: {
    code: "CSPDI",
    url: "/producto/creditosimple/presencia_digital",
  },
  // Flux (factoraje): empresas con las que se usará la línea. Solo existe en el wizard v2.
  uso_de_linea: {
    code: "CSADL",
    url: "/v2/producto/creditosimple/uso_de_linea",
  },
  datos_accionista: {
    code: "CSDAL",
    url: "/producto/creditosimple/datos_accionista",
  },
  rfc_curp: {
    code: "CSCDA",
    url: "/producto/creditosimple/rfc_curp",
  },
  domicilio_accionista: {
    code: "CSDAV",
    url: "/producto/creditosimple/domicilio_accionista",
  },
  consulta_buro: {
    code: "CSABA",
    url: "/producto/creditosimple/consulta_buro",
  },
  buro_bloqueado: {
    code: "CSBBC",
    url: "/producto/creditosimple/buro_bloqueado",
  },
  informacion_garantia: {
    code: "CSIGA",
    url: "/producto/creditosimple/informacion_garantia",
  },
  informacion_multigarantias: {
    code: "CSIGA",
    url: "/producto/creditosimple/informacion_multigarantias",
  },
  desicion_sat: {
    code: "CSDSA",
    url: "/producto/creditosimple/desicion_sat",
  },
  documentos_sat: {
    code: "CSDOS",
    url: "/producto/creditosimple/documentos_sat",
  },
  consulta_buro_pm: {
    code: "CSABE",
    url: "/producto/creditosimple/consulta_buro_pm",
  },
  // tofu pfae
  datos_empresa_pfae: {
    code: "CSDEM",
    url: "/producto/creditosimple/datos_empresa_pfae",
  },
  domicilio_pfae: {
    code: "CSDOE",
    url: "/producto/creditosimple/domicilio_pfae",
  },
  presencia_digital_pfae: {
    code: "CSPDI",
    url: "/producto/creditosimple/presencia_digital_pfae",
  },
  consulta_buro_pfae: {
    code: "CSABA",
    url: "/producto/creditosimple/consulta_buro_pfae",
  },
  // waiting room
  waiting_room: {
    code: "CSCOF",
    url: "/producto/creditosimple/waiting_room",
  },
  oferta: {
    code: "CSAAO",
    url: "/producto/creditosimple/oferta",
  },
  waiting_room_revision: {
    code: "CREVC",
    url: "/producto/creditosimple/waiting_room_revision",
  },
  esperando_oferta: {
    code: "CSEOF",
    url: "/producto/creditosimple/esperando_oferta",
  },
  // bofu pm
  check_list: {
    code: "CSBEX",
    url: "/producto/creditosimple/check_list",
  },
  documentos_dictamen: {
    code: "CSDDI",
    url: "/producto/creditosimple/docs_empresa",
  },
  dictamen_juridico: {
    code: "CSDIC",
    url: "/producto/creditosimple/docs_empresa",
  },
  avance_expediente_digital: {
    code: "CSAED",
    url: "/producto/creditosimple/avance_expediente_digital",
  },
  validando_expediente_pm: {
    code: "CSEDC",
    url: "/producto/creditosimple/validando_expediente_pm",
  },
  errores_expediente_pm: {
    code: "CSECI",
    url: "/producto/creditosimple/errores_expediente_pm",
  },
  expediente_digital_validado: {
    code: "CSVCC",
    url: "/producto/creditosimple/completado",
  },
  // este estatus tiene 3 pantallas diferentes:
  //    agenda_visita - pantalla inicial
  //    agenda_visita_pm - pantalla para agregar nueva direccion
  //    confirmacion_domicilio - pantalla si ya hay una direccion confirmada
  agendar_visita: {
    code: "CSVCL",
    url: "/producto/creditosimple/agenda_visita",
  },
  // visita agendada
  visita_agendada: {
    code: "CSAVC",
    url: "/producto/creditosimple/confirmacion_visita_agendada",
  },
  // estos estatus comparten la misma pantalla: /
  validacion_documentos_ext: {
    code: "CSVDE",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  datos_documentos_valor: {
    code: "CSDDV",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  en_espera_documento_visita: {
    code: "CSVDV",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  validacion_Visita: {
    code: "CSVYC",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  revision_control: {
    code: "CSRIC",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  // estos estatus comparten la misma pantalla: /firma_documentos
  emision_documentos_valor: {
    code: "CSEVD",
    url: "/producto/creditosimple/visita_ocular_concluida",
  },
  bienvenida_firma: {
    code: "CSBAF",
    url: "/producto/creditosimple/bienvenida_firma",
  },
  firma_representante_legal: {
    code: "CSFRL",
    url: "/producto/creditosimple/firma_documentos",
  },
  firma_otros: {
    code: "CSFIR",
    url: "/producto/creditosimple/firma_otros",
  },
  validacion_firma: {
    code: "CSVDF",
    url: "/producto/creditosimple/bofu_completado",
  },
  dispersion: {
    code: "CSDIS",
    url: "/producto/creditosimple/bofu_completado",
  },
  // estos estatus comparten la misma pantalla: /bofu_completado
  firma_ext_envio_exp: {
    code: "CSFIE",
    url: "/producto/creditosimple/bofu_completado",
  },
  cliente_completo: {
    code: "CSCLI",
    url: "/producto/creditosimple/bofu_completado",
  },
  // -----
  actas_identificacion: {
    code: "CSIYA",
    url: "/producto/creditosimple/actas_identificacion",
  },
  // bofu pfae
  informacion_documentos_pfae: {
    code: "CSBEX",
    url: "/producto/creditosimple/informacion_documentos_pfae",
  },
  avance_expediente_digitalPFAE: {
    code: "CSAED",
    url: "/producto/creditosimple/avance_expediente_digitalPFAE",
  },
  validando_expediente_pfae: {
    code: "CSEDC",
    url: "/producto/creditosimple/validando_expediente_pfae",
  },
  errores_expediente_pfae: {
    code: "CSECI",
    url: "/producto/creditosimple/errores_expediente_pfae",
  },
  // Rechazado onboarding
  rechazado_modelo: {
    code: "CSREC",
    url: "/producto/creditosimple/credito_rechazado",
  },
  rechazado_revision: {
    code: "CSRER",
    url: "/producto/creditosimple/credito_rechazado",
  },
  // Rechazado Underwritting
  rechazo_expediente: {
    code: "CSRDO",
    url: "/producto/creditosimple/rechazado_documentacion",
  },
  rechazo_formalizacion: {
    code: "CSRFO",
    url: "/producto/creditosimple/rechazado_documentacion",
  },
  rechazo_contratacion: {
    code: "CSRCO",
    url: "/producto/creditosimple/rechazado_documentacion",
  },
  datos_oficiales: {
    code: "CSDOF",
    url: "/producto/creditosimple/datos_oficiales",
  },
  consulta_buro_pf: {
    code: "CSABA",
    url: "/producto/creditosimple/consulta_buro_pf",
  },
  informacion_plataforma: {
    code: "CSIP1",
    url: "/producto/creditosimple/informacion_plataforma",
  },
  oferta_pf: {
    code: "CSAAO",
    url: "/producto/creditosimple/oferta_pf",
  },
  expediente_pf: {
    code: "CSAED",
    url: "/producto/creditosimple/expediente_pf",
  },
  validacion_expediente_pf: {
    code: "CSEDC",
    url: "/producto/creditosimple/validacion_expediente_pf",
  },
  bienvenida_firma_pf: {
    code: "CSBAF",
    url: "/producto/creditosimple/bienvenida_firma_pf",
  },
  firma_pf: {
    code: "CSFRL",
    url: "/producto/creditosimple/firma_documentos_pf",
  },
  validacion_firma_pf: {
    code: "CSVDF",
    url: "/producto/creditosimple/validacion_firma_pf",
  },
  // arrendamiento
  seleccion_vehiculos: {
    code: "CSSAC",
    url: "/producto/arrendamiento/seleccion_vehiculos",
  },
  uso_vehiculos: {
    code: "CSUDC",
    url: "/producto/arrendamiento/uso_vehiculos",
  },
  informacion_bancaria: {
    code: "CSIBA",
    url: "/producto/arrendamiento/informacion_bancaria",
  },
  errores_expediente_pf: {
    code: "CSECI",
    url: "/producto/creditosimple/errores_expediente_pf",
  },
  uso_moto: {
    code: "CUSMO",
    url: "/producto/arrendamiento/uso_moto",
  },
};

export const STATUS_TOFU = [
  STATUS_CATALOG.registro_datos_personales.code,
  STATUS_CATALOG.validacion_telefono.code,
  STATUS_CATALOG.datos_empresa_pfae.code,
  STATUS_CATALOG.domicilio_pfae.code,
  STATUS_CATALOG.consulta_ciec.code,
  STATUS_CATALOG.uso_de_credito.code,
  STATUS_CATALOG.presencia_digital_pfae.code,
  STATUS_CATALOG.consulta_buro_pfae.code,
  STATUS_CATALOG.datos_empresa_pm.code,
  STATUS_CATALOG.presencia_digital.code,
  STATUS_CATALOG.datos_accionista.code,
  STATUS_CATALOG.rfc_curp.code,
  STATUS_CATALOG.domicilio_accionista.code,
  STATUS_CATALOG.consulta_buro.code,
  STATUS_CATALOG.informacion_garantia.code,
  STATUS_CATALOG.informacion_multigarantias.code,
  STATUS_CATALOG.seleccion_vehiculos.code,
  STATUS_CATALOG.uso_vehiculos.code,
  STATUS_CATALOG.informacion_bancaria.code,
];

export const STATUS_TOFU_BY_SCREEN_PF = {
  registro_datos_personales: [
    STATUS_CATALOG.registro_datos_personales.code,
    STATUS_CATALOG.datos_oficiales.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.informacion_plataforma.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  datos_oficiales: [
    STATUS_CATALOG.datos_oficiales.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.informacion_plataforma.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  uso_vehiculos: [
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.informacion_plataforma.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  domicilio_pf: [
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.informacion_plataforma.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  consulta_buro_pf: [
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.informacion_plataforma.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  seleccion_vehiculos: [
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  informacion_bancaria: [
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.uso_moto.code,
  ],
  uso_moto: [
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.consulta_buro_pf.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.uso_moto.code,
    STATUS_CATALOG.informacion_plataforma.code,
  ],
  informacion_plataforma: [STATUS_CATALOG.informacion_plataforma.code, STATUS_CATALOG.uso_moto.code],
  waiting_room: [STATUS_CATALOG.waiting_room.code],
  oferta_pf: [STATUS_CATALOG.oferta_pf.code],
  expediente_pf: [STATUS_CATALOG.expediente_pf.code, STATUS_CATALOG.errores_expediente_pf.code],
  validacion_expediente_pf: [
    STATUS_CATALOG.validacion_expediente_pf.code,
    STATUS_CATALOG.datos_documentos_valor.code,
    STATUS_CATALOG.emision_documentos_valor.code,
    STATUS_CATALOG.validacion_documentos_ext.code,
  ],
  bienvenida_firma_pf: [STATUS_CATALOG.bienvenida_firma_pf.code],
  firma_pf: [STATUS_CATALOG.firma_pf.code],
  validacion_firma_pf: [STATUS_CATALOG.validacion_firma_pf.code],
  errores_expediente_pf: [STATUS_CATALOG.errores_expediente_pf.code],
};

export const STATUS_TOFU_BY_SCREEN_PFAE = {
  registro_datos_personales: [
    STATUS_CATALOG.registro_datos_personales.code,
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  validacion_telefono: [
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  datos_empresa_pfae: [
    STATUS_CATALOG.datos_empresa_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  domicilio_pfae: [
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  desicion_sat: [
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  documentos_sat: [
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  consulta_ciec: [
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  informacion_garantia: [
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  uso_vehiculos: [
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  informacion_multigarantias: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  uso_de_credito: [
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  presencia_digital: [
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  consulta_buro_pfae: [
    STATUS_CATALOG.registro_datos_personales.code,
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital_pfae.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.domicilio_pfae.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  buro_bloqueado: [
    STATUS_CATALOG.buro_bloqueado.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  seleccion_vehiculos: [
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
  informacion_bancaria: [
    STATUS_CATALOG.informacion_bancaria.code,
    STATUS_CATALOG.consulta_buro_pfae.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
  ],
};

export const STATUS_TOFU_BY_SCREEN_PM = {
  registro_datos_personales: [
    STATUS_CATALOG.registro_datos_personales.code,
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pm.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  validacion_telefono: [
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pm.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  datos_empresa_pm: [
    STATUS_CATALOG.datos_empresa_pm.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  desicion_sat: [
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  documentos_sat: [
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  consulta_buro_pm: [
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  consulta_ciec: [
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  informacion_garantia: [
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  informacion_multigarantias: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  uso_de_credito: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  uso_vehiculos: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  presencia_digital: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  datos_accionista: [
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  rfc_curp: [
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  domicilio_accionista: [
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  consulta_buro: [
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
  buro_bloqueado: [STATUS_CATALOG.buro_bloqueado.code],
  seleccion_vehiculos: [
    STATUS_CATALOG.registro_datos_personales.code,
    STATUS_CATALOG.validacion_telefono.code,
    STATUS_CATALOG.datos_empresa_pm.code,
    STATUS_CATALOG.consulta_ciec.code,
    STATUS_CATALOG.uso_de_credito.code,
    STATUS_CATALOG.informacion_garantia.code,
    STATUS_CATALOG.informacion_multigarantias.code,
    STATUS_CATALOG.presencia_digital.code,
    STATUS_CATALOG.datos_accionista.code,
    STATUS_CATALOG.rfc_curp.code,
    STATUS_CATALOG.domicilio_accionista.code,
    STATUS_CATALOG.consulta_buro.code,
    STATUS_CATALOG.seleccion_vehiculos.code,
    STATUS_CATALOG.uso_vehiculos.code,
    STATUS_CATALOG.desicion_sat.code,
    STATUS_CATALOG.documentos_sat.code,
    STATUS_CATALOG.consulta_buro_pm.code,
  ],
};

export const STATUS_BOFU_PM = {
  waiting_room: [STATUS_CATALOG.waiting_room.code],
  check_list: [STATUS_CATALOG.check_list.code],
  dictamen: [
    STATUS_CATALOG.documentos_dictamen.code,
    STATUS_CATALOG.dictamen_juridico.code,
    STATUS_CATALOG.avance_expediente_digital.code,
    STATUS_CATALOG.errores_expediente_pm.code,
    STATUS_CATALOG.validando_expediente_pm.code,
  ],
  llenado_expediente: [
    STATUS_CATALOG.documentos_dictamen.code,
    STATUS_CATALOG.avance_expediente_digital.code,
    STATUS_CATALOG.errores_expediente_pm.code,
    STATUS_CATALOG.dictamen_juridico.code,
    STATUS_CATALOG.validando_expediente_pm.code,
  ],
  validando_expediente: [STATUS_CATALOG.validando_expediente_pm.code],
  errores_expediente_pm: [STATUS_CATALOG.errores_expediente_pm.code],
  completado: [STATUS_CATALOG.expediente_digital_validado.code],
  agendar_visita: [STATUS_CATALOG.agendar_visita.code],
  visita_agendada: [STATUS_CATALOG.visita_agendada.code],
  visita_concluida: [
    STATUS_CATALOG.en_espera_documento_visita.code,
    STATUS_CATALOG.validacion_Visita.code,
    STATUS_CATALOG.revision_control.code,
    STATUS_CATALOG.validacion_documentos_ext.code,
    STATUS_CATALOG.datos_documentos_valor.code,
  ],
  bofu_completado: [
    STATUS_CATALOG.firma_ext_envio_exp.code,
    STATUS_CATALOG.cliente_completo.code,
    STATUS_CATALOG.firma_otros.code,
    STATUS_CATALOG.validacion_firma.code,
  ],
  bienvenida_firma: [STATUS_CATALOG.bienvenida_firma.code],
  firma_documentos: [
    STATUS_CATALOG.emision_documentos_valor.code,
    STATUS_CATALOG.firma_representante_legal.code,
    STATUS_CATALOG.dispersion.code,
  ],
  firma_otros: [STATUS_CATALOG.firma_otros.code],
  rechazado_onboarding: [STATUS_CATALOG.rechazado_modelo.code, STATUS_CATALOG.rechazado_revision.code],
  rechazado_underwritting: [
    STATUS_CATALOG.rechazo_expediente.code,
    STATUS_CATALOG.rechazo_formalizacion.code,
    STATUS_CATALOG.rechazo_contratacion.code,
  ],
};

export const STATUS_BOFU_PFAE = {
  waiting_room: [STATUS_CATALOG.waiting_room.code],
  expediente_digitalPFAE: [STATUS_CATALOG.avance_expediente_digitalPFAE.code],
  rechazado_onboarding: [STATUS_CATALOG.rechazado_modelo.code, STATUS_CATALOG.rechazado_revision.code],
  bienvenida_firma: [STATUS_CATALOG.bienvenida_firma.code],
  firma_documentos: [STATUS_CATALOG.firma_representante_legal.code, STATUS_CATALOG.firma_otros.code],
  firma_otros: [STATUS_CATALOG.firma_otros.code],
};

export const TAX_SYSTEMS = {
  PM: {
    code: "CS001",
  },
  PFAE: {
    code: "CS002",
  },
};

export const TAX_SYSTEM_TYPE = {
  PM: {
    code: "PM",
  },
  PF: {
    code: "PF",
  },
  PFAE: {
    code: "PFAE",
  },
};

export const CLIENT_RFC_NOT_VALID = ["XAXX010101000"];

export const DOCUMENTS_CATALOG = {
  acta_constitutiva: {
    code: "DAC",
  },
  identificacion_representante_legal: {
    code: "DIORL",
  },
  acta_adicional: {
    code: "DAA",
  },
  estado_cuenta_bancario: {
    code: "DECB",
  },
  constancia_situacion_fiscal: {
    code: "DCDF",
  },
  comprobante_domicilio: {
    code: "DCD",
  },
  comprobante_domicilio_confirmado: {
    code: "DCDC",
  },
  comprobante_domicilio_operativo: {
    code: "DCDO",
  },
  anexo_1: {
    code: "ANX1",
  },
  anexo_2: {
    code: "ANX2",
  },
  solicitud_credito: {
    code: "SDC",
  },
  identificacion_oficial: {
    code: "DIO",
  },
  validacion_identidad: {
    code: "VIDME",
  },
  cierre_anual: {
    code: "EFCA",
  },
  ultimo_cierre_parcial: {
    code: "EFUCP",
  },
  estados_finacieros: {
    code: "EFDEF",
  },
  estado_cuenta_bancario_zona_gris: {
    code: "DECZG",
  },
  acta_matrimonio: {
    code: "DAMCA",
  },
  tabla_amortizacion: {
    code: "FDTAM",
  },
  dictamen_juridico: {
    code: "CDDTN",
  },
  comprobante_domicilio_personal: {
    code: "DCCDP",
  },
  buro_persona: {
    code: "PEDBP",
  },
};

export const PAYMENT_METHOD_CATALOG = {
  otro: {
    code: "CPIOT",
  },
};

/**
 * Tipos de PEP. A diferencia de los demás catálogos, `peps-type` no expone un `code`: solo trae
 * `id`, `name` y `description`, así que el emparejamiento es por nombre.
 */
export const PEP_TYPE_CATALOG = {
  socio: {
    name: "Socio",
  },
  familiar: {
    name: "Familiar",
  },
};

export const PERSON_CATALOG = {
  propietario_real: {
    code: "PTPR",
  },
  representante_legal: {
    code: "PTRL",
  },
  accionista_mayoritario: {
    code: "PTAM",
  },
  // TODO: DEPRECATED
  representante_legal_accionista_mayoritario: {
    code: "PRLAM",
  },
  // TODO: DEPRECATED
  representante_legal_propietario_real: {
    code: "PRLPR",
  },
  // TODO: DEPRECATED
  accionista_mayoritario_propietario_real: {
    code: "PAMPR",
  },
  // TODO: DEPRECATED
  representante_legal_accionista_mayoritario_propietario_real: {
    code: "PRLAP",
  },
  conyuge_aval: {
    code: "PTCAV",
  },
  dueno_pfae: {
    code: "PTD",
  },
  segundo_aval: {
    code: "PTSAV",
  },
  obligado_solidario: {
    code: "PFOBS",
  },
  co_acreditado: {
    code: "PTCOA",
  },
  garante: {
    code: "PFGAR",
  },
  // Mercader: "Quién llena esta solicitud" en `RegistroDatosPersonalesMercader`.
  titular_rfc: {
    code: "PTTDR",
  },
  administrador_consultorio: {
    code: "PTDDC",
  },
};

export const SIGNATURE_TYPE = {
  digital: "DIGITAL",
  fisica: "FISICA",
};

// TODO: DEPRECATED
export const PERSON_CODES_LEGAL_REPRESENTATIVE = [
  PERSON_CATALOG.representante_legal.code,
  PERSON_CATALOG.representante_legal_accionista_mayoritario.code,
  PERSON_CATALOG.representante_legal_propietario_real.code,
  PERSON_CATALOG.representante_legal_accionista_mayoritario_propietario_real.code,
];

export const PEP_CODES = {
  propio: {
    code: "CPEPP",
    name: "Propio",
  },
  familiar: {
    code: "CPEPF",
    name: "Familiar",
  },
};

export const DEFAULT_HOST_VALUE = "lendia";

export const HOSTNAMES = [
  //Lendia
  {
    host: "dev-clientes.lenditgroup.com",
    value: "lendia",
  },
  {
    host: "clientes.lendia.mx",
    value: "lendia",
  },
  //Lendia Demo
  {
    host: "demo-clientes.lenditgroup.com",
    value: "lendia_demo",
  },
  {
    host: "demo-clientes.lendia.mx",
    value: "lendia_demo",
  },
  //Finbe
  {
    host: "dev-clientes-finbe.lenditgroup.com",
    value: "finbe",
  },
  {
    host: "clientes-pyme.finbeabc.com.mx",
    value: "finbe",
  },
  //Market Place
  {
    host: "dev-clientes-marketplace.lenditgroup.com",
    value: "market_place",
  },
  {
    host: "clientes.pymio.mx",
    value: "market_place",
  },
  // Finbra
  {
    host: "dev-clientes-finbra.lenditgroup.com",
    value: "finbra",
  },
  {
    host: "clientes-finbra.lendia.mx",
    value: "finbra",
  },
  {
    host: "d1a1u6im4zb2ah.cloudfront.net",
    value: "finbra",
  },
  // Now Ports
  {
    host: "dev-clientes-nowports.lenditgroup.com",
    value: "now_ports",
  },
  {
    host: "clientes-nowports.lendia.mx",
    value: "now_ports",
  },
  {
    host: "d3s298pygo12kj.cloudfront.net",
    value: "now_ports",
  },
  // Avanza Solido
  {
    host: "dev-clientes-avanza-solido.lenditgroup.com",
    value: "avanza_solido",
  },
  {
    host: "clientes-avanzasolido.lendia.mx",
    value: "avanza_solido",
  },
  {
    host: "d3rtfrvw4awb4b.cloudfront.net",
    value: "avanza_solido",
  },
  // Kapital Flex
  {
    host: "dev-clientes-kapital-flex.lenditgroup.com",
    value: "kapital_flex",
  },
  {
    host: "clientes-aceleraflex.kapitalflex.mx",
    value: "kapital_flex",
  },
  // providencia
  {
    host: "dev-clientes-providencia.lenditgroup.com",
    value: "providencia",
  },
  {
    host: "demo-clientes-providencia.lendia.mx",
    value: "providencia",
  },
  // sfi
  {
    host: "demo-sfi-clientes.lenditgroup.com",
    value: "sfi",
  },
  {
    host: "demo-sfi-clientes.lendia.mx",
    value: "sfi",
  },
  {
    host: "dev-clientes-sfi.lenditgroup.com",
    value: "sfi",
  },
  {
    host: "clientes-sfi.lendia.mx",
    value: "sfi",
  },
  // afirme
  {
    host: "demo-clientes-afirme.lenditgroup.com",
    value: "afirme",
  },
  {
    host: "demo-clientes-afirme.lendia.mx",
    value: "afirme",
  },
  // santander
  {
    host: "demo-clientes-santander.lenditgroup.com",
    value: "santander",
  },
  {
    host: "demo-clientes-santander.lendia.mx",
    value: "santander",
  },
  // actinver
  {
    host: "dev-clientes-actinver.lenditgroup.com",
    value: "actinver",
  },
  {
    host: "demo-clientes-actinver.lendia.mx",
    value: "actinver",
  },
  // arra capital
  {
    host: "dev-clientes-arracapital.lenditgroup.com",
    value: "arra_capital",
  },
  {
    host: "clientes-arracapital.lendia.mx",
    value: "arra_capital",
  },
  // lanit auto
  {
    host: "dev-clientes-lanitauto.lenditgroup.com",
    value: "lanitauto",
  },
  {
    host: "clientes-lanitauto.lendia.mx",
    value: "lanitauto",
  },
  // bbva
  {
    host: "dev-clientes-bbva.lenditgroup.com",
    value: "bbva",
  },
  {
    host: "demo-clientes-bbva.lendia.mx",
    value: "bbva",
  },
  // credimoto
  {
    host: "dev-clientes-micredimoto.lenditgroup.com",
    value: "micredimoto",
  },
  {
    host: "clientes-micredimoto.lendia.mx",
    value: "micredimoto",
  },
  // nafin
  {
    host: "dev-clientes-nafin.lenditgroup.com",
    value: "nafin",
  },
  {
    host: "demo-clientes-nafin.lendia.mx",
    value: "nafin",
  },
  // incredit
  {
    host: "dev-clientes-incredit.lenditgroup.com",
    value: "incredit",
  },
  {
    host: "demo-clientes-incredit.lendia.mx",
    value: "incredit",
  },
  // banbajio
  {
    host: "dev-clientes-banbajio.lenditgroup.com",
    value: "banbajio",
  },
  {
    host: "demo-clientes-banbajio.lendia.mx",
    value: "banbajio",
  },
  // wu wei
  {
    host: "dev-clientes-wuwei.lenditgroup.com",
    value: "wuwei",
  },
  {
    host: "clientes-wuwei.lendia.mx",
    value: "wuwei",
  },
  // credivive
  {
    host: "dev-clientes-credivive.lenditgroup.com",
    value: "credivive",
  },
  {
    host: "clientes-credivive.lendia.mx",
    value: "credivive",
  },
  // vivemoto
  {
    host: "dev-clientes-vivemoto.lenditgroup.com",
    value: "vivemoto",
  },
  {
    host: "clientes-vivemoto.lendia.mx",
    value: "vivemoto",
  },
  // kipy
  {
    host: "clientes-kipy.lendia.mx",
    value: "kipy",
  },
  // flux
  {
    host: "dev-clientes-flux.lenditgroup.com",
    value: "flux",
  },
   // mercerder
  {
    host: "dev-clientes-mercader.lenditgroup.com",
    value: "mercader",
  },
  // Local
  {
    host: "localhost",
    value: import.meta.env.VITE_LOCALHOST_CONFIG || "market_place",
  },
];

export const ADDRESS_CODES = {
  particular: {
    code: "CDPA",
  },
  operativo: {
    code: "CDOP",
  },
  operativo_confirmado: {
    code: "CDOC",
  },
  laboral: {
    code: "CDDL",
  },
  fiscal: {
    code: "CDFI",
  },
};

export const MATRIMONIAL_REGIMEN_CODES = {
  sociedad_conyugal: {
    code: "RSC",
  },
  separacion_bienes: {
    code: "RSB",
  },
};

export const GUARANTEE_TYPE = {
  vehiculos: { code: "GTVHO", name: "Vehiculos" },
  vehicular: { code: "GTVHA", name: "Vehicular" },
  maquinaria: { code: "GTMAQ", name: "Maquinaria" },
  inmobiliaria: { code: "GTIMB", name: "Inmobiliaria" },
  cuentas: { code: "GTCC", name: "Cuentas por cobrar" },
  inmuebles: { code: "GTINM", name: "Inmuebles" },
  mobiliario: { code: "GTMOB", name: "Mobiliario" },
  no_dispongo_de_cuentas: { code: "GTSCC", name: "No dispongo de cuentas por cobrar" },
  grantia_hipotecaria: { code: "GTGHP", name: "Garantía Hipotecaria" },
  grantia_prendaria: { code: "GTGPR", name: "Garantía Prendaria" },
  cesion_flujos: { code: "GTCEF", name: "Cesión de flujos o contratos" },
  prendaria: { code: "GTPRE", name: "Prendaria" },
  FEGA: { code: "GFEGA", name: "Fondo Especial de Asistencia Técnica y Garantía" },
  FONAGA: { code: "GFONA", name: "Fondo Nacional de Garantías" },
  liquida: { code: "GTLIQ", name: "Liquida" },
  solidaria: { code: "GSOLI", name: "Solidaria" },
};

export const BOFU_TABS_CONFIG: BofuTabConfig = {
  tab_dictamen: {
    code: "TBDIC",
    url: "/producto/creditosimple/docs_empresa",
  },
  tab_empresa: {
    code: "TBEMP",
    url: "/producto/creditosimple/avance_expediente_digital",
  },
  tab_aval: {
    code: "TBAVL",
    url: "/producto/creditosimple/docs_aval",
  },
  tab_propietario: {
    code: "TBPRO",
    url: "/producto/creditosimple/propietario_real_pm",
  },
  tab_garantia: {
    code: "TBGRT",
    url: "/producto/creditosimple/docs_garantia",
  },
  tab_representante: {
    code: "TBREP",
    url: "/producto/creditosimple/docs_representante",
  },
  tab_representante_pf: {
    code: "TBEPF",
    url: "",
  },
  tab_documentos_sat: {
    code: "TBSAT",
    url: "",
  },
  tab_documentos_actividad: {
    code: "TBACT",
    url: "",
  },
  tab_personas: {
    code: "TBPER",
    url: "/producto/creditosimple/docs_persona",
  },
};

export const PODUCT_ID_SECOND_GUARANTEE = "07d918f6-f885-4351-a440-a0ac6b206495";

export const TAX_SYTEM_ID_SECOND_GUARANTE = "8bf1abe6-5bed-4b6e-a8c1-3f4f764638eb";

export const SECOND_GUARANTEE_STATUS_INITIAL = {
  code: "CDALA",
  url: "/avales/registro_aval",
  sequence: 100,
  status_id: "a0f5e1ea-fff5-4abd-90c3-ef855a6e8abf",
};

export const SECOND_GUARANTEE_STATUS_FINAL = {
  code: "CFFAA",
  url: "/avales/expediente_completado_aval",
  sequence: 1000,
  status_id: "0281d5c2-2892-457b-b699-de598c5a0fda",
};

export const TAX_SYSTEM_TYPE_SECONDGUARANTEE = {
  PERSON: {
    code: "PTSAV",
  },
};

export const IDENTITY_VALIDATION_NUMBER_OF_ATTEMPTS = 5;

export const INVALID_BANK_ACCOUNT_CODE = "000";

/** Dígitos de una CLABE. Al completarlos se resuelve el banco con sus 3 primeros. */
export const CLABE_LENGTH = 18;

/**
 * Rutas del expediente en el wizard nuevo, para que las pantallas no las repitan a mano. El `path`
 * tiene que coincidir con el `path` del `<Route>` correspondiente en `routerv2.tsx`, que los declara
 * como literal.
 */
export const PATHS_EXPEDIENTE_V2 = {
  checkList: {
    path: "/v2/producto/creditosimple/check_list",
  },
  dictamen: {
    path: "/v2/producto/creditosimple/docs_dictamen",
  },
  empresa: {
    path: "/v2/producto/creditosimple/docs_empresa",
  },
  informacionSolicitud: {
    path: "/v2/producto/creditosimple/expediente_informacion_solicitud",
  },
  informacionBancaria: {
    path: "/v2/producto/creditosimple/expediente_informacion_bancaria",
  },
  referencias: {
    path: "/v2/producto/creditosimple/expediente_referencias",
  },
  personas: {
    path: "/v2/producto/creditosimple/expediente_personas",
  },
  validacionIdentidad: {
    path: "/v2/producto/creditosimple/expediente_validacion_identidad",
  },
  revision: {
    path: "/v2/producto/creditosimple/expediente_revision",
  },
};

/** Valores de `business_group` en la cuenta: el backend lo guarda como texto, en mayúsculas. */
export const BUSINESS_GROUP = {
  si: "SI",
  no: "NO",
} as const;

/** Correo de contacto que se muestra al usuario cuando necesita ayuda (ej. el código SMS no llega). */
export const EMAIL_CONTACTO = "contacto@lendia.mx";

/**
 * Rutas de acceso del diseño nuevo (login y recuperación de contraseña). El `path` tiene que
 * coincidir con el del `<Route>` de `LenditRoute.tsx`.
 */
export const PATHS_AUTH_V2 = {
  login: {
    path: "/v2/login",
  },
  recuperarContrasena: {
    path: "/v2/recuperar_contrasena",
  },
  nuevaContrasena: {
    path: "/v2/nueva_contrasena",
  },
} as const;

/**
 * Rutas de los cotizadores del diseño nuevo, por tipo de producto. Se migran por tenant en
 * `CotizadoresV2`; el `path` tiene que coincidir con el del `<Route>` de `LenditRoute.tsx`.
 */
export const PATHS_COTIZADORES_V2 = {
  credito_simple: {
    path: "/v2/solicita_tu_credito",
  },
} as const;

/**
 * Rutas del tofu en el wizard nuevo, en el orden del flujo. Mismo trato que
 * `PATHS_EXPEDIENTE_V2`: el `path` tiene que coincidir con el del `<Route>` de `routerv2.tsx`, que
 * los declara como literal.
 */
export const PATHS_TOFU_V2 = {
  cotizador: {
    path: "/v2/producto/creditosimple/cotizador",
  },
  crearCuenta: {
    path: "/v2/producto/creditosimple/crear_cuenta",
  },
  registroDatosPersonales: {
    path: "/v2/producto/creditosimple/registro_datos_personales",
  },
  validacionTelefono: {
    path: "/v2/producto/creditosimple/validacion_telefono",
  },
  // Mercader: perfil de ingresos y egresos del médico (`PerfilIngresosMercader`), status CSPIE.
  perfilIngresos: {
    path: "/v2/producto/creditosimple/perfil_ingresos",
  },
  // Status CSDEM: empresa, grupo empresarial, uso del crédito y canales digitales en una pantalla.
  informacionEmpresa: {
    path: "/v2/producto/creditosimple/informacion_empresa",
  },
  consultaCiec: {
    path: "/v2/producto/creditosimple/consulta_ciec",
  },
  decisionIngreso: {
    path: "/v2/producto/creditosimple/decision_ingreso",
  },
  cargaDocumentos: {
    path: "/v2/producto/creditosimple/carga_documentos",
  },
  // PFAE sin CIEC: domicilio fiscal (`DomicilioFiscalPfae`), mismo status CSDOE que el legacy `domicilio_pfae`.
  domicilioFiscalPfae: {
    path: "/v2/producto/creditosimple/domicilio_fiscal_pfae",
  },
  nipBuro: {
    path: "/v2/producto/creditosimple/nip_buro",
  },
  usoDeCredito: {
    path: "/v2/producto/creditosimple/uso_de_credito",
  },
  presenciaDigital: {
    path: "/v2/producto/creditosimple/presencia_digital",
  },
  conexionCuentas: {
    path: "/v2/producto/creditosimple/conexion_cuentas",
  },
  // Flux (factoraje): empresas con las que se usará la línea. Aún sin status en el backend.
  usoLinea: {
    path: "/v2/producto/creditosimple/uso_de_linea",
  },
  datosAccionista: {
    path: "/v2/producto/creditosimple/datos_accionista",
  },
  domicilioAccionista: {
    path: "/v2/producto/creditosimple/domicilio_accionista",
  },
  consultaBuro: {
    path: "/v2/producto/creditosimple/consulta_buro",
  },
  confirmacionAccionista: {
    path: "/v2/producto/creditosimple/confirmacion_accionista",
  },
  informacionMultigarantias: {
    path: "/v2/producto/creditosimple/informacion_multigarantias",
  },
  waitingRoom: {
    path: "/v2/producto/creditosimple/waiting_room",
  },
  seleccionandoOferta: {
    path: "/v2/producto/creditosimple/seleccionando_oferta",
  },
  ofertaAceptada: {
    path: "/v2/producto/creditosimple/oferta_aceptada",
  },
};

export const BOFU_TABS_FORM_CODES = {
  solicitud_credito: "SOLICITUD_CREDITO",
  validacion_identidad: "VALIDACION_IDENTIDAD",
  referencias_personales: "REFERENCIAS_PERSONALES",
  informacion_bancaria: "INFORMACION_BANCARIA",
  informacion_aval: "INFORMACION_AVAL",
  informacion_representante_legal: "INFORMACION_REPRESENTANTE_LEGAL",
  datos_laborales_economicos: "DATOS_LABORALES_ECONOMICOS",
  formularios_persona: "FORMULARIOS_PERSONA",
};

export const VISUAL_CONFIG_CODES = {
  CHECKLIST_EXPEDIENTE: "CHECKLIST_EXPEDIENTE",
  CHECKLIST_FIRMA: "CHECKLIST_FIRMA",
  CHECKLIST_VISITA_OCULAR: "CHECKLIST_VISITA_OCULAR",
} as const;

export type VisualConfigCode = (typeof VISUAL_CONFIG_CODES)[keyof typeof VISUAL_CONFIG_CODES];

// tipos de validacion de documentos soportados por el servicio de validacion
export const DOCUMENT_VALIDATION_TYPES: Record<string, BofuTabValidationType> = {
  estado_cuenta_bancario: "bank_statement",
  comprobante_domicilio: "proof_of_address",
  constancia_situacion_fiscal: "tax_status",
  visita_ocular: "site_visit",
  identificacion_oficial: "official_identification",
};

export const REFERENCE_DEAFUALT_VALUES = {
  min: 3,
  required: 3,
};

export const REFERENCES_CODES = {
  cliente: "CRTCL",
  proveedor: "CRTPR",
  empresa: "CRTEM",
  personal: "CRTRP",
  otro: "CRTOT",
} as const;

export const DEFAULT_NUMBER_BANK_STATEMENTS = 3;
export const MAX_ACCOUNTS_ALLOWED = 5;

/**
 * Perfil de ingresos y egresos (`api/serviceMonthly`). Los `id` de los catálogos cambian entre ambientes;
 * en la lógica del front se usa el `code`, que es fijo.
 */
export const SERVICE_MONTHLY_SEGMENT = {
  medico: "MEDICO",
};

/** Catálogo de servicios que generan ingreso (`service_monthly_income`). */
export const SERVICE_MONTHLY_INCOME_CODES = {
  consultas: "SMICO",
  estudios: "SMIES",
  analisis_laboratorio: "SMIAL",
  cirugias: "SMICI",
  procedimientos_ambulatorios: "SMIPA",
  terapias_rehabilitacion: "SMITR",
  tratamientos_esteticos: "SMITE",
  honorarios_hospitalarios: "SMIHH",
  /** Exige `other_service_name`. */
  otro_servicio: "SMIOT",
};

/** Catálogo de conceptos de egreso mensual (`service_monthly_outcome`). */
export const SERVICE_MONTHLY_OUTCOME_CODES = {
  renta: "SMORE",
  insumos: "SMOIN",
  nomina_honorarios: "SMONH",
  servicios_mantenimiento: "SMOSM",
  gastos_personales: "SMOGP",
  otros_gastos: "SMOOT",
};

export const LEASING_TYPE_CODES = {
  VEHICULAR: "LTVHA",
  MOTOCICLETAS: "LTMTA",
  // Equipo médico (Mercader), en el orden del diseño.
  IMAGENOLOGIA: "LTIMA",
  QUIRURGICO_HOSPITALARIO: "LTQHA",
  DENTAL: "LTDTA",
  LABORATORIO_DIAGNOSTICO: "LTLDA",
  CONSULTORIO_MOBILIARIO: "LTCMA",
  ESTETICA_DERMATOLOGIA: "LTEDA",
  REHABILITACION_TERAPIA: "LTRTA",
  OTRO_EQUIPO_MEDICO: "LTOEA",
};
